/*
 * Listing the conversations by (auto-generated) title, with CSV download
 */
import React from 'react';

import { createFileRoute } from '@tanstack/react-router';
import { Download } from 'lucide-react';

import { useConversationHeaders, useDownloadConversations } from '@/lib/api';

import { Button } from '@/components/ui/button';
import { formatDateTime } from '@/lib/utils';

export const Route = createFileRoute('/conversations')({
    component: ConversationsPage,
});

function ConversationsPage() {
    const query = undefined;
    const limit = 10;
    const skip = 0;

    const { data: conversations } = useConversationHeaders({
        query,
        limit,
        skip,
    });

    const { downloadConversations } = useDownloadConversations();
    const handleDownload = async () => {
        await downloadConversations();
    };

    return (
        <div className="flex-1" data-testid="Conversations">
            <div className="flex flex-row px-8 pt-8 gap-2">
                <Button size="sm" onClick={handleDownload}>
                    <Download className="h-4 w-4 mr-2" />
                    Download All Time
                </Button>
            </div>

            <div className="flex flex-col pt-8 px-8 gap-1">
                <h3 className="text-lg pb-2">Last {limit} conversations</h3>
                {conversations
                    ?.filter((c) => c.title.length > 0)
                    .map((c) => (
                        <div
                            key={c.id}
                            className={`
                            flex flex-row items-center rounded bg-white max-w-[500px] justify-between
                            px-3 py-1
                            `}
                        >
                            <div className="leading-relaxed">{c.title}</div>
                            <div className="text-zinc-600 text-sm">
                                {formatDateTime(c.createdAt)}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
}
